module.exports = __webpack_public_path__ + "img/IMG_8157_L_BlackMatted_MockedUp.0a27ccd6.jpg";